import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Button,
  TextField
} from '@material-ui/core';


import validate from 'validate.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { doLogout } from 'actions/user.js';
import md5 from 'md5';
import { SIREN_CONFIG, CONFIG_SETTINGS } from 'config.js';
import {useSelector} from 'react-redux';
import {FormattedMessage, useIntl } from "react-intl";


const AccountDetails = props => {
  const { className, user, history, doLogout, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const facility_id = useSelector((store) => store.user.facility_id);
  const facility_name = useSelector((store) => store.user.facility_name);


  const schema = {

    admin_name: {
      presence: { allowEmpty: false, message: `^${formatMessage({id:'admin_name_required'})}` },
      length: {
        maximum: 20
      }
    },

    cur_password: {
      presence: { allowEmpty: false, message: `^${formatMessage({id:'cur_password_required'})}` },
      length: {
        maximum: 32
      }
    },

    new_password: {
      presence: { allowEmpty: false, message: `^${formatMessage({id:'new_password_required'})}` },
      length: {
        maximum: 32
      }
    },

    confirm_password: {
      presence: { allowEmpty: true, message: `^${formatMessage({id:'confirm_password_required'})}` },
      length: {
        maximum: 32
      }
    },

  };


  const initialState = {
    admin_id: user.admin_id,
    admin_name: user.admin_name,
    cur_password: '',
    new_password: '',
    confirm_password: ''
  };


  const [formState, setFormState] = useState({
    isValid: false,
    values: initialState,
    touched: {},
    errors: {}
  });


  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {},
    }));


  }, [formState.values]);


  const handleChange = event => {

    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));


    if (event.target.name == 'confirm_password'){
      if (formState.values.new_password !== formState.values.confirm_password){
        formState.values.confirm_password = [formatMessage({id:'not_match_password'})];
      }
    }
  };


  const handleSubmit = event => {

    if(formState.values.admin_id === ''){
      formState.touched.admin_id = true;
      formState.errors.admin_id = ['ID is required'];
    }

    if(formState.values.admin_name === ''){
      formState.touched.admin_name = true;
      formState.errors.admin_name = [formatMessage({id:'should_input_admin_name'})];
    }

    if(formState.values.cur_password === ''){
      formState.touched.cur_password = true;
      formState.errors.cur_password = [formatMessage({id:'should_input_cur_password'})];
    }

    //새비밀번호가 입력되면 체크한 후, 정상이면 비밀번호 업데이트 처리하고,
    //새비밀번호가 입력되지 않으면, 비밀번호 업데이트 처리하지 않음.
    if (formState.values.new_password.length > 0 &&
      formState.values.confirm_password.length > 0 ){

      //pw 일치
      if (formState.values.new_password !== formState.values.confirm_password){
        formState.touched.confirm_password = true;
        formState.errors.confirm_password = [formatMessage({id:'not_match_password'})];
      }
    }
    else {
      if(formState.values.new_password === ''){
        formState.touched.new_password = true;
        formState.errors.new_password = [formatMessage({id:'should_input_new_password'})];
      }

      if(formState.values.confirm_password === ''){
        formState.touched.confirm_password = true;
        formState.errors.confirm_password = [formatMessage({id:'should_input_confirm_password'})];
      }
    }


    if(hasError('admin_id') || hasError('admin_name') || hasError('cur_password')
      || hasError('new_password') || hasError('confirm_password') ) {

      setFormState(formState => ({
        ...formState,
        errors: formState.errors,
      }));
      return;
    }

    var post_body = {};

    if (formState.values.new_password.length > 0){
      post_body = {
        admin_id: formState.values.admin_id,
        admin_name: formState.values.admin_name,
        current_password: md5(formState.values.cur_password),
        new_password: md5(formState.values.new_password)
      };
    } else {
      post_body = {
        admin_id: formState.values.admin_id,
        admin_name: formState.values.admin_name,
        current_password: md5(formState.values.cur_password),
      };
    }

    fetch(`${SIREN_CONFIG.HOSTNAME}/account/update`,
    {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body:
        JSON.stringify(post_body)
    })
    .then( response => {
      return response.json();
    })
    .then (responseData => {

      if (responseData.resultCode === "000") {
        alert(formatMessage({id:'update_successful'}));

        localStorage.setItem(CONFIG_SETTINGS.USER_INFO,
          JSON.stringify({
            status: 'on',
            admin_id: formState.values.admin_id,
            admin_name: formState.values.admin_name,
            facility_id: responseData.facility_id,
            facility_name: responseData.facility_name
          })
        );

        setTimeout( () => {
          window.location.href = '/';
        }, 500);

      } else {
        //에러
        console.log(responseData);
        alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
      }
    });
  }



  const handleLogout = event => {

    props.doLogout();

    setTimeout( () => {
      window.location.href = '/sign-in';
    }, 500);
  }


  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;


  const handleBack = () => {
    history.goBack();
  };


  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <form autoComplete="off" noValidate>
        <CardHeader
            className={classes.card_header}
            title={formatMessage({id:'account_profile'})}
            titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }}
        />
        <Divider />

        <CardContent>
          <Grid container spacing={2}>

            <Grid item md={12} xs={12}>
              <TextField
                label={formatMessage({id:'facility_id'})}
                name="facility_id"
                fullWidth
                disabled
                type="text"
                value={facility_id}
                variant="outlined"
              />
            </Grid>

            <Grid item md={12} xs={12}>
              <TextField
                label={formatMessage({id:'facility_name'})}
                name="facility_name"
                fullWidth
                disabled
                type="text"
                value={facility_name}
                variant="outlined"
              />
            </Grid>


            <Grid item md={12} xs={12}>
              <TextField
                label="ID"
                name="admin_id"
                fullWidth
                error={hasError('admin_id')}
                helperText={
                  hasError('admin_id') ? formState.errors.admin_id[0] : null
                }
                onChange={handleChange}
                disabled
                type="text"
                value={formState.values.admin_id || ''}
                variant="outlined"
              />
            </Grid>


            <Grid item md={12} xs={12}>
              <TextField
                label={formatMessage({id:'admin_name'})}
                name="admin_name"
                fullWidth
                error={hasError('admin_name')}
                helperText={
                  hasError('admin_name') ? formState.errors.admin_name[0] : null
                }
                onChange={handleChange}
                type="text"
                value={formState.values.admin_name || ''}
                variant="outlined"
              />
            </Grid>


            <Grid item md={12} xs={12} >
              <TextField
                fullWidth
                label={formatMessage({id:'cur_password'})}
                name="cur_password"
                onChange={handleChange}
                type="password"
                error={hasError('cur_password')}
                helperText={hasError('cur_password') ? formState.errors.cur_password[0] : null }
                value={formState.values.cur_password || ''}
                variant="outlined"
              />
            </Grid>


            <Grid item md={12} xs={12} >
              <TextField
                fullWidth
                label={formatMessage({id:'new_password'})}
                name="new_password"
                onChange={handleChange}
                type="password"
                error={hasError('new_password')}
                helperText={hasError('new_password') ? formState.errors.new_password[0] : null }
                value={formState.values.new_password || ''}
                variant="outlined"
              />
            </Grid>


            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label={formatMessage({id:'confirm_password'})}
                name="confirm_password"
                onChange={handleChange}
                type="password"
                error={hasError('confirm_password')}
                helperText={
                  hasError('confirm_password') ? formState.errors.confirm_password[0] : null
                }
                value={formState.values.confirm_password || ''}
                variant="outlined"
              />
            </Grid>

          </Grid>


          <Grid container className={classes.action}>

            <Grid item md={8} xs={12}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.action}
                onClick={handleSubmit}
              >
                <FormattedMessage id="update" />
              </Button>

              <Button
                variant="outlined"
                size="large"
                onClick={handleBack}
                className={classes.action}
              >
                <FormattedMessage id="cancel" />
              </Button>
            </Grid>

            <Grid item align="right" md={4} xs={12}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                className={classes.action}
                onClick={handleLogout}
              >
                <FormattedMessage id="logout" />
              </Button>
            </Grid>

          </Grid>


        </CardContent>
      </form>
    </Card>
  );
};

AccountDetails.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({ doLogout }, dispatch)
}

let mapStateToProps = (state) => {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountDetails);


const useStyles = makeStyles((theme) => ({
  root: {},

  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },
  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
}));
